// Local state resolvers using apollo link state.

export const defaults = {
  alertType: '',
  alertMessage: '',
  unitFilterId: '',
  chapterFilterId: '',
  categoryId: '',
  unitId: '',
  chapterId: '',
  activityTypeId: '',
  level: '',
  subjectIds: [],
  isFree: false,
  // _id: '',
  // name: '',
  // photo: '',
  // email: '',
  
  projectStatusFilter: 'active',
  projectCollectionFilter: '',
  projectSubjectFilter: '',
  // schoolId: '',
  // schoolTitle: ''
};

export const resolvers = {
  Query: () => ({}),
  Mutation: {
    SetCategory: (_, { categoryId }, { cache }) => {
      cache.writeData({ data: { categoryId } });
      return null;
    },
    SetUnit: (_, { unitId }, { cache }) => {
      cache.writeData({ data: { unitId } });
      return null;
    },
    SetActivityFilters: (_, { unitFilterId, chapterFilterId }, { cache }) => {
      console.log(unitFilterId, chapterFilterId);
      const data = { unitFilterId, chapterFilterId };
      cache.writeData({ data });
      return data;
    },
    SetChapter: (_, { chapterId }, { cache }) => {
      cache.writeData({ data: { chapterId } });
      return null;
    },  
    SetActivityType: (_, { activityTypeId }, { cache }) => {
      cache.writeData({ data: { activityTypeId } });
      return null;
    },
    SetLevel: (_, { level }, { cache }) => {
      cache.writeData({ data: { level } });
      return null;
    },
    SetSubjects: (_, { subjectIds }, { cache }) => {
      cache.writeData({ data: { subjectIds } });
      return null;
    },
    SetIsFree: (_, { isFree }, { cache }) => {
      cache.writeData({ data: { isFree } });
      return null;
    },
    CreateAlert: (_, { type, message }, { cache }) => {
      const data = { alertType: type, alertMessage: message };
      cache.writeData({ data });
      return data;
    },
    SetSchool: (_, { schoolId, schoolTitle }, { cache }) => {
      console.log(schoolId, schoolTitle);
      const data = { schoolId, schoolTitle }
      cache.writeData({ data });
      return data;
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/resolvers/index.js